export const metaInfo = {
  home: {
    title: "Coschool | Powering Schools To Become Future Ready",
    meta_title: "Coschool | Powering Schools To Become Future Ready",
    description: "Personalise student learning, empower teachers, partner with parents, and drive outcomes — with SchoolAi by Coschool, a closed-loop learning platform.",
    h1: "Every student deserves one-on-one attention - now, every school can provide it."
  },
  about_us: {
    title: 'About Coschool | Reimagining Education with AI',
    meta_title: 'About Coschool | Our Story & Vision',
    description: 'Meet the people and purpose behind Coschool. Discover how we\'re building AI-powered tools to make education personal, joyful, and data-smart.',
    h1: 'Making learning the greatest joy'
  },
  careers: {
    title: 'Careers at Coschool | Build the Future of Education',
    meta_title: 'Careers at Coschool | Join Our Team',
    description: 'Be part of Coschool\'s journey to reimagine education. Discover how your work can make learning more meaningful, personal, and impactful.',
    h1: 'Work at Coschool – Be Part of the Next Chapter in Education'
  },
  privacy_policy: {
    title: 'Coschool Privacy Policy | How We Protect Your Data',
    meta_title: 'Coschool Privacy Policy',
    description: 'Your privacy matters. Learn how Coschool collects, uses, and protects your data.',
    h1: 'Our Privacy Policy – Your Data, Our Responsibility'
  },
  terms_and_conditions: {
    title: 'Terms and Conditions | Coschool',
    meta_title: 'Coschool Terms and Conditions',
    description: 'Review the terms and conditions for using Coschool services.',
    h1: 'Terms and Conditions'
  },
  demorun: {
    title: 'Demo Run - Coschool',
    meta_title: 'Demo Run - SchoolAi by Coschool',
    description: 'Experience SchoolAi by Coschool in action with our interactive demo.',
    h1: 'Demo Run'
  },
  demoprofiles: {
    title: 'Demo Profiles - Coschool',
    meta_title: 'Demo Profiles - SchoolAi by Coschool',
    description: 'Explore demo profiles for students, teachers, and parents on SchoolAi by Coschool.',
    h1: 'Demo Profiles'
  },
  school_partner: {
    title: 'School Partner - Coschool',
    meta_title: 'School Partner - SchoolAi by Coschool',
    description: 'Partner with Coschool to transform your school with AI-powered learning solutions.',
    h1: 'Become a School Partner'
  },
  test_ai_readiness: {
    title: 'AI Readiness Test - Coschool',
    meta_title: 'AI Readiness Test - SchoolAi by Coschool',
    description: 'Assess your school\'s readiness for AI-powered learning with our comprehensive readiness test.',
    h1: 'AI Readiness Test'
  },
  demo: {
    title: 'Demo - Coschool',
    meta_title: 'Demo - SchoolAi by Coschool',
    description: 'Experience SchoolAi by Coschool with our interactive demo.',
    h1: 'Demo'
  },
  teachers_day_2026: {
    title: "Happy Teacher's Day — Your Report Card",
    meta_title: "Happy Teacher's Day — Your Report Card",
    description: 'A quick, playful report card for Teacher\'s Day — from all of us at Coschool.'
  },
  teachers_day_2026_parents: {
    title: "Happy Teacher's Day — For the First Teacher",
    meta_title: "Happy Teacher's Day — For the First Teacher",
    description: 'A quick, playful report card for Teacher\'s Day — from all of us at Coschool.'
  }
}
